import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <footer
      style={{
        margin: 0,
        padding: 0,
        height: "40px",
        backgroundColor: "#0000CD",
        position: "fixed",
        bottom: 0,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <Container fluid className="p-0 m-0">
        <Row className="m-0">
          <Col className="p-0 text-white text-center">
            {new Date().getFullYear()} © NHS NEQAS . All Rights Reserved
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
